import React from "react"

import { CreateProjectTeamMembersOverlay } from "./CreateProjectTeamMembersOverlay"
import { useCreateProjectTeamMembersOverlayModel } from "./model/useCreateProjectTeamMembersOverlayModel"
import { CreateProjectTeamMembersOverlayPayload } from "./types/CreateProjectTeamMembersOverlayPayload"

export interface CreateProjectTeamMembersOverlayConnectorProps {
  payload: CreateProjectTeamMembersOverlayPayload
}

export const CreateProjectTeamMembersOverlayConnector = React.memo(
  (props: CreateProjectTeamMembersOverlayConnectorProps) => {
    return (
      <CreateProjectTeamMembersOverlay
        {...useCreateProjectTeamMembersOverlayModel(props)}
      />
    )
  }
)
